import { getCoreSettings } from '../model/core-settings';
import { fetchMEventsAPI } from './fetch-m-events-api';
import { fetchProduction } from './fetch-production';

/**
 * appConfig can come from the following sources:
 * 1. in DEV environment
 *   - from locally saved file: public/layoutSettings.json
 *   - from m-events API
 * 2. in new deployment from /cms-settings/${eventId}_vmRevolution_false.json
 */
export const fetchAppConfig = async () => {
  const coreSettings = getCoreSettings();

  if (coreSettings.appConfigFrom === 'm-events') return fetchMEventsAPI(coreSettings);

  return fetchProduction();
};
